var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRightWithTailinline = function SvgArrowRightWithTailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.943 1.057a1.333 1.333 0 1 0-1.886 1.886l5.724 5.724H2.001a1.333 1.333 0 1 0 0 2.666h20.78l-5.724 5.724a1.333 1.333 0 1 0 1.886 1.886l8-8a1.329 1.329 0 0 0 .3-1.426 1.329 1.329 0 0 0-.3-.46l-8-8Z",
    fill: "#040404"
  })));
};

export default SvgArrowRightWithTailinline;